module.exports = __webpack_public_path__ + "img/digifinex_logo.8793f5a9.png";